module.exports = __webpack_public_path__ + "img/2.d32c6ce6.png";